// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#cookie-consent{display:flex}#cookie-consent .cookie-msg a{color:#fff;text-decoration:underline}#cookie-consent .btn{color:#fff;border:1px solid #fff;border-radius:50px;font-size:14px;padding:0 50px}", ""]);
// Exports
module.exports = exports;
